















import { defineComponent, computed } from '@nuxtjs/composition-api'
import { useContent } from '~/composables/useContent'
import { ContentPart, ContentBlock } from '~/types/content'

const mapBlocksTypeID = {
  'block-1-banner': 'BlocksDynamicSliderBanner',
  'block-3-banner': 'BlocksDynamicBannerTightCol3',
  'block-2-banner': 'BlocksDynamicBannerLooseCol2',
  'block-4-product': 'BlocksDynamicSliderProduct',
  'block-5-product': 'BlocksDynamicSliderProduct',
  'block-3-news': 'BlocksDynamicNewsCols3',
  'block-form-01': 'BlocksDynamicForm',
  'block-form-02': 'BlocksDynamicForm',
  default: 'BlocksContentDefault',
}

const mapBlocksSliderCols = {
  'block-4-product': 4,
  'block-5-product': 5,
  default: 5,
}

export default defineComponent({
  name: 'ContentsBlocks',

  setup() {
    const { content } = useContent()

    const blocks = computed(
      () => (content.value?.[ContentPart.Blocks] as ContentBlock[]) ?? []
    )

    return {
      mapBlocksTypeID,
      mapBlocksSliderCols,
      blocks,
    }
  },
})
